export default __webpack_public_path__ + "static/media/RightFog.74f934d0.png";